import React, { Component, FunctionComponent, useMemo } from 'react';
import { filter, map, omit, startCase } from 'lodash';
import * as actions from '../actions';
import * as jobActions from '../jobActions';
import * as jobCostActions from '../jobCostActions';
import * as contractorActions from '../contractorActions';
import * as employeeActions from '../employeeActions';
import * as reportActions from '../reportActions';
import * as siteVisitActions from '../siteVisitActions';
import { IJobEditChildProps } from './jobEdit';
import { useSaveRoot } from '../saveRoot';
import { ModelCollection, getCollection } from '../store';
import { IOperationsModelFacade, operationsModelFacadeFactory } from '../models/operationsModelFacade';
import { IJob } from '../models/jobModel';
import { IJobCost } from '../models/jobCostModel';
import { ISiteVisit } from '../models/siteVisitModel';
import { IPatchOperation, PatchOpType } from '../modelFactory';
import { IJobIssue, JobIssueStatus } from 'Scripts/models/jobIssueModel';
import { Expander, sortableComponent } from './sharedComponents';
import util from 'Scripts/util';
import { Map } from 'immutable';
import { IEmployee } from 'Scripts/models/employeeModel';
import { IFile } from 'Scripts/models/fileModel';
import { IJobCostWorkArea } from 'Scripts/models/jobCostWorkAreaModel';
import { IVendor } from 'Scripts/models/vendorModel';


function EditJobIssueModal() {
	return <div className='window'>
		<header><button className='cancel'><span>Cancel</span></button><span>Edit &bull; 1 Issue</span><button className='save'><span>Save</span></button></header>
		<div className='views'>
			<div className='content in scrollable'>
				<table className='editIssue' cellPadding='0' cellSpacing='0'>
					<tbody>
						<tr>
							<td></td>
							<td><strong>Work Area</strong></td>
							<td>
								<select className="select" placeholder="Select">
									<option value="">Select</option>
									<option value="" selected>Kitchen</option>
									<option value="">Master Bath</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Source</strong></td>
							<td>
								<select className="select" placeholder="Select">
									<option value="">Select</option>
									<option value="">Builder/Client</option>
									<option value="" selected>Cabinet Supplier</option>
									<option value="">Designer</option>
									<option value="">Another option</option>
									<option value="">More options</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Issue</strong></td>
							<td>
								<select className="select" placeholder="Select">
									<option value="">Select</option>
									<option value="">Thermofoil peeling /cut short/ wrinkling</option>
									<option value="" selected>Wrong Product Sent</option>
									<option value="">Edge Tape Quality</option>
									<option value="">Another option</option>
									<option value="">More options</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Description</strong></td>
							<td><textarea placeholder='Description'>Install lower shelf, center panel #11 came without glaze 70.5</textarea></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Material</strong></td>
							<td>
								<table className='compact' cellPadding='0' cellSpacing='0'>
									<tbody>
										<tr className=''>
											<td></td>
											<td className=''>
												<select className="select" placeholder="Manufacturer">
													<option value="">Select Manufacturer</option>
													<option value="">Kitchen Craft</option>
													<option value="">Warehouse</option>
													<option value="">Another</option>
												</select>
											</td>
											<td className=''><input type='text' placeholder='Product Name' autoCapitalize='' autoCorrect='off' value='' />
											</td>
											<td className=''><input type='text' placeholder='PO Number' value='' /></td>
											<td className='action'><button className='icon iconOnly addItem'><span></span></button></td>
											<td></td>
										</tr>
										<tr className=''>
											<td></td>
											<td className=''>
												<select className="select" placeholder="Manufacturer">
													<option value="">Select Manufacturer</option>
													<option value="" selected>Kitchen Craft</option>
													<option value="">Warehouse</option>
													<option value="">Another</option>
												</select>
											</td>
											<td className=''><input type='text' placeholder='Product Name' autoCapitalize='' autoCorrect='off' value='1-WEP11' />
											</td>
											<td className=''><input type='text' placeholder='PO Number' value='56784' /></td>
											<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
											<td></td>
										</tr>
									</tbody>
								</table>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Estimate</strong></td>
							<td>
								<select className="select" placeholder="Estimate (optional)">
									<option value="">Estimate (optional)</option>
									<option value="">0.5 hour</option>
									<option value="">1 hour</option>
									<option value="">2 hour</option>
									<option value="">Another option</option>
									<option value="">More options</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Personnel</strong></td>
							<td>
								<select className="select" placeholder="Who should resolve this? (optional)">
									<option value="">Who should resolve this? (optional)</option>
									<option value="">Bob Smith</option>
									<option value="">Darryl Philbin</option>
									<option value="">Another option</option>
									<option value="">More options</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Photos</strong></td>
							<td>
								<div className="photos">
									<div className="photoControl large">
										<div className="uploadPhoto add"></div>
										<input type="file" accept="image/*" capture="environment" />
									</div>
									<div className="photoControl large">
										<div className="uploadPhoto" style={{ backgroundImage: 'url("/images/_demo_photo2.jpg")'}}></div>
									</div>
								</div>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>;
}

function EditJobIssuesModal() {
	return <div className='window'>
		<header><button className='cancel'><span>Cancel</span></button><span>Edit &bull; 2 Issues</span><button className='save'><span>Save</span></button></header>
		<div className='views'>
			<div className='content in scrollable'>
				<table className='' cellPadding='0' cellSpacing='0'>
					<thead>
						<tr>
							<td></td>
							<td>Source</td>
							<td>Material</td>
							<td>P.O.</td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td></td>
							<td>Kitchen Craft</td>
							<td>1 Item</td>
							<td className=''><input type='text' placeholder='PO Number' value='56784' /></td>
							<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td>Warehouse</td>
							<td>1 Item</td>
							<td className=''><input type='text' placeholder='PO Number' value='54555' /></td>
							<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>;
}

function ScheduleIssueModal() {
	return <div className='window'>
		<header><button className='cancel'><span>Cancel</span></button><span>Schedule Service &bull; 1 Issue &bull; 1 hour</span><button className='save'><span>SCHEDULE</span></button></header>
		<div className='views'>
			<div className='content in scrollable'>
				<table className='' cellPadding='0' cellSpacing='0'>
					<tbody>
						<tr>
							<td></td>
							<td><strong>Assign to</strong></td>
							<td>
								<select className="select" placeholder="Select">
									<option value="">Select</option>
									<option value="" selected>Bob Smith</option>
									<option value="">Darryl Philbin</option>
									<option value="">Another option</option>
									<option value="">More options</option>
								</select>
							</td>
							<td></td>
						</tr>
						<tr>
							<td></td>
							<td><strong>Date</strong></td>
							<td>
								<div className='DayPickerInput'><input placeholder='Select' className='dataList' type='text' value='' /></div>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>;
}

const newAndScheduledIssueColumns = {
	spacer1: { isSpacer: true },
	checkboxes: { className: 'checkboxes', isCheckbox: true },
	issueNumber: { name: 'No.', className: 'issue' },
	source: { name: 'Source', className: 'source' },
	description: { name: 'Description', className: 'description' },
	estimate: { name: 'Estimate', className: 'estimate' },
	material: { name: 'Material', className: 'material' },
	poNumber: { isSpacer: true, className: 'po' },
	location: { isSpacer: true, className: 'location' },
	photos: { isSpacer: true, name: 'Photos', className: 'action' },
	actions: { isSpacer: true, className: 'action' },
	spacer2: { isSpacer: true },
};

const orderIssueColumns = {
	spacer1: { isSpacer: true },
	checkboxes: { className: 'checkboxes', isCheckbox: true },
	issueNumber: { name: 'No.', className: 'issue' },
	source: { name: 'Source', className: 'source' },
	description: { name: 'Description', className: 'description' },
	manufacturer: { name: 'Manufacturer', className: 'manufacturer' },
	material: { name: 'Material', className: 'material' },
	poNumber: { isSpacer: true, className: 'po' },
	location: { isSpacer: true, className: 'location' },
	photos: { isSpacer: true, name: 'Photos', className: 'action' },
	actions: { isSpacer: true, className: 'action' },
	spacer2: { isSpacer: true },
};

const readyToScheduleIssueColumns = {
	spacer1: { isSpacer: true },
	checkboxes: { className: 'checkboxes', isCheckbox: true },
	issueNumber: { name: 'No.', className: 'issue' },
	source: { name: 'Source', className: 'source' },
	description: { name: 'Description', className: 'description' },
	estimate: { name: 'Estimate', className: 'estimate' },
	material: { name: 'Material', className: 'material' },
	poNumber: { name: 'P.O.', className: 'po' },
	location: { name: 'Location', className: 'location' },
	photos: { isSpacer: true, name: 'Photos', className: 'action' },
	actions: { isSpacer: true, className: 'action' },
	spacer2: { isSpacer: true },
};

interface IssueRowData {
    key: string;
    issueNumber: number;
    assignedTo?: string;
    source?: string;
    description: string;
    estimate?: string;
    material?: string;
    manufacturer?: string;
    poNumber?: string;
    location?: string;
    photoCount: number;
    isSelected?: boolean;
}

interface IssueRowParams {
    allToggled?: boolean;
    openActions?: ()=>void;
    toggleRow?: (key: string)=>void;
    toggleAll?: ()=>void;
    openPhotos?: ()=>void;
}

function TableHeader({ columns, sortKey, updateSort, allToggled, toggleAll }: { columns: Record<string, any>, sortKey?: string, updateSort: any } & IssueRowParams) {
	return (
		<thead>
			<tr>
				{ map(columns, (def, key) => {
					if(def.isSpacer) {
						return <td key={ key } className={ def.className }>{ def.name ?? '' }</td>
					} else if(def.isCheckbox) {
						return <td key={ key } className="checkboxes"><label><input type="checkbox" readOnly={ true } checked={ allToggled } onClick={ e => { e.preventDefault(); toggleAll() }} /></label></td>
					}
					else {
						return <td key={ key } className={ key === sortKey? `{def.className} sorted`: def.className } onClick={ () => updateSort(key) }>{ def.name }</td>
					}
				}) }
			</tr>
		</thead>
	);
}

function NewOrScheduledIssueRow({ key, issueNumber, source, description, estimate, material, photoCount, isSelected, openActions, openPhotos, toggleRow}: IssueRowData & IssueRowParams) {
	return <tr>
		<td></td>
		<td className="checkboxes"><label><input type="checkbox" readOnly={ true } checked={ isSelected } onClick={e => { e.preventDefault(); toggleRow(key); } } /></label></td>
		<td className="issue"><span className='issueNumber'>{ issueNumber }</span></td>
		<td className='source'>{ source }</td>
		<td className='description'>{ description }</td>
		<td className='estimate'>{ estimate }</td>
		<td className='material' colSpan={3}>{ material }</td>
		<td className='action' onClick={ () => openPhotos } ><button className='icon iconOnly photos disabled'><span>{ photoCount }</span></button></td>
		<td className='action' onClick={ () => openActions() }><button className='icon iconOnly contextMenu'><span></span></button></td>
		<td></td>
	</tr>;
}

function OrderIssueRow({ key, issueNumber, source, description, material, manufacturer, photoCount, isSelected, openActions, openPhotos, toggleRow}: IssueRowData & IssueRowParams) {
	return <tr>
		<td></td>
		<td className="checkboxes"><label><input type="checkbox" readOnly={ true } checked={ isSelected } onClick={e => { e.preventDefault(); toggleRow(key); } } /></label></td>
		<td className="issue"><span className='issueNumber'>{ issueNumber }</span></td>
		<td className='source'>{ source }</td>
		<td className='description'>{ description }</td>
		<td className='manufacturer'>{ manufacturer }</td>
		<td className='material' colSpan={3}>{ material }</td>
		<td className='action' onClick={ () => openPhotos } ><button className='icon iconOnly photos disabled'><span>{ photoCount }</span></button></td>
		<td className='action' onClick={ () => openActions() }><button className='icon iconOnly contextMenu'><span></span></button></td>
		<td></td>
	</tr>;
}

function ReadyToScheduleIssueRow({ key, issueNumber, source, description, material, location, poNumber, photoCount, isSelected, openActions, openPhotos, toggleRow}: IssueRowData & IssueRowParams) {
	return <tr>
		<td></td>
		<td className="checkboxes"><label><input type="checkbox" readOnly={ true } checked={ isSelected } onClick={e => { e.preventDefault(); toggleRow(key); } } /></label></td>
		<td className="issue"><span className='issueNumber'>{ issueNumber }</span></td>
		<td className='source'>{ source }</td>
		<td className='description'>{ description }</td>
		<td className='material'>{ material }</td>
		<td className='po'>{ poNumber }</td>
		<td className='location'>{ location }</td>
		<td className='action' onClick={ () => openPhotos } ><button className='icon iconOnly photos disabled'><span>{ photoCount }</span></button></td>
		<td className='action' onClick={ () => openActions() }><button className='icon iconOnly contextMenu'><span></span></button></td>
		<td></td>
	</tr>;
}

const IssueTable = sortableComponent(({ updateSort, sortKey, list, columns, rowComponent, allToggled, openActions, toggleAll, toggleRow, openPhotos }: { updateSort: any, sortKey?: string, list: IssueRowData[], columns: Record<string, any>, rowComponent: FunctionComponent<IssueRowParams> } & IssueRowParams) => {
	const rows = [];
	const Row = rowComponent;
    
	list.forEach(item => rows.push(<Row { ...item } allToggled={ allToggled } openActions={ openActions } openPhotos={ openPhotos } toggleRow={ toggleRow }></Row>));

	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<TableHeader updateSort={updateSort} sortKey={sortKey} columns={ columns } allToggled={ allToggled } toggleAll={ toggleAll } />
			<tbody>
				{ rows }
			</tbody>
		</table>
	);
});

function NewIssueVisitSection({ employees, visit, allIssues, jobFiles, workAreas }: { employees: Map<string, IEmployee>, visit: ISiteVisit, allIssues: IJobIssue[], jobFiles: IFile[], workAreas: IJobCostWorkArea[] } ) {
	const visitEmployee = employees.get(visit.primaryEmployee?.employeeKey)
	const visitTypeString = startCase(visit.type);
	const subTitle = visitEmployee? `${visitTypeString} by ${visitEmployee.fullName}`: visitTypeString;
	const issues: IssueRowData[] = allIssues.filter(i => i.currentStatus === JobIssueStatus.received && i.sourceVisitKey === visit.key).map(i => {
		const workAreaName = workAreas?.find(wa => wa.key === i.workAreaKey)?.name;
		return {
			key: i.key,
			isSelected: false,
			issueNumber: i.issueNumber,
			source: i.source,
			description: workAreaName? `${workAreaName} • ${i.description}`: i.description,
			estimate: i.estimatedMinutes? `${i.estimatedMinutes} min`: '',
			material: i.materialItems? i.materialItems.toArray().map(m => m.productName).join(' • '): '-',
			photoCount: jobFiles.filter(f => f.relatedTypeKey === i.key).length
		}
	});
	const actions = [
		<button className='icon iconOnly editItem disabled'><span></span></button>,
		<button className='icon iconOnly moveItem disabled'><span></span></button>
	];
	
	return <Expander title={ util.dateHelper.formatDate(visit.scheduledDate, { format: 'MM/dd/yyyy' }) } subTitle={ subTitle } contentClassNames={['inner', 'clearfix']} actions={ actions }>
		{
			<IssueTable list={ issues } columns={ newAndScheduledIssueColumns } rowComponent={ NewOrScheduledIssueRow } />
		}
	</Expander>   
}

function NewIssuesSection({ employees, issues, visits, jobFiles, workAreas }: { employees: Map<string, IEmployee>, issues: IJobIssue[], visits: ISiteVisit[], jobFiles: IFile[], workAreas: IJobCostWorkArea[] }) {
	const pertinentVisits = visits.filter(v => issues.some(i => i.scheduledVisitKey === v.key)).sort((a:ISiteVisit,b:ISiteVisit) => (a.currentStatusDate?.getDate() || 0) - (b.currentStatusDate?.getDate() || 0));
	return <Expander title='New Issues'>
		{
			pertinentVisits.map(v => <NewIssueVisitSection key={ v.key } visit={ v } employees={ employees } allIssues={ issues } jobFiles={ jobFiles } workAreas={ workAreas } /> )
		}
	</Expander>;
}

function ProcessSection({ issues, jobFiles, vendors, workAreas }: { issues: IJobIssue[], jobFiles: IFile[], vendors: Map<string, IVendor>, workAreas: IJobCostWorkArea[] }) {
	const issuesToOrder: IssueRowData[] = issues.filter(i => i.materialItems?.toArray().some(m => !m.poNumber)).map(i => {
		const workArea = workAreas?.find(wa => wa.key === i.workAreaKey);
		const workAreaName = workArea?.name;
		const vendorName = vendors.get(workArea?.vendorKey??'')?.name;
		return {
			key: i.key,
			isSelected: false,
			issueNumber: i.issueNumber,
			source: i.source,
			description: workAreaName? `${workAreaName} • ${i.description}`: i.description,
			manufacturer: vendorName ?? '-',
			material: i.materialItems? i.materialItems.toArray().map(m => m.productName).join(' • '): '-',
			photoCount: jobFiles.filter(f => f.relatedTypeKey === i.key).length
		}
	});
	const issuesToSchedule: IssueRowData[] = issues.filter(i => i.materialItems?.toArray().every(m => !!m.poNumber)).map(i => {
		const workAreaName = workAreas?.find(wa => wa.key === i.workAreaKey)?.name;
		
		return {
			key: i.key,
			isSelected: false,
			issueNumber: i.issueNumber,
			source: i.source,
			description: workAreaName? `${workAreaName} • ${i.description}`: i.description,
			estimate: i.estimatedMinutes? `${i.estimatedMinutes} min`: '',
			material: i.materialItems? i.materialItems.toArray().map(m => m.productName).join(' • '): '-',
			poNumber: i.materialItems?.toArray().map(m => m.poNumber).join(', '),
			location: 'FROM ACCUMATICA',
			photoCount: jobFiles.filter(f => f.relatedTypeKey === i.key).length
		}
	});
	const mainActions = [
		<button className='icon iconOnly addItemWhite'><span></span></button>
	];
	const orderActions = [
		<button className='icon iconOnly print'><span></span></button>,
		<button className='icon iconOnly editItem disabled'><span></span></button>
	];
	const scheduleActions = [
		<button className='icon iconOnly scheduleItem disabled'><span></span></button>,
		<button className='icon iconOnly editItem disabled'><span></span></button>
	];
	return <Expander title="Process" actions={ mainActions }>
		<Expander title="Material to Order" contentClassNames={['inner', 'clearfix']} actions={ orderActions }>
			<IssueTable list={ issuesToOrder } columns={ orderIssueColumns } rowComponent={ OrderIssueRow } />
		</Expander>
		<Expander title="Ready to Schedule" subTitle='2 hours' contentClassNames={['inner', 'clearfix']} actions={ scheduleActions }>
			<IssueTable list={ issuesToSchedule } columns={ readyToScheduleIssueColumns } rowComponent={ ReadyToScheduleIssueRow } />
		</Expander>
	</Expander>
}

function ScheduledSection() {
	return <section className='expander expanded'>
		<header><button tabIndex={ -1 }><span>Scheduled <span className='options'></span></span></button>
			<div className='icon iconExpander'><span></span><span></span></div>
			<div className='actions'><button className='icon iconOnly addItemWhite'><span></span></button></div>
		</header>
		<div className=''>

			{/* Visit */}
			<section className='expander expanded'>
				<header><button tabIndex={ -1 }><span>06/01/20 <span className='subtitle'>3 hours</span></span></button>
					<div className='icon iconExpander'><span></span><span></span></div>
					<div className='actions'>
						<button className='icon iconOnly print'><span></span></button>
						<button className='icon iconOnly editItem disabled'><span></span></button>
					</div>
				</header>
				<div>
					<div className='inner clearfix'>
						<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td className="checkboxes"><label><input type="checkbox" /></label></td>
									<td className='issue sorted'>No.</td>
									<td className='assignedTo'>Assigned to</td>
									<td className='description'>Description</td>
									<td className='estimate'>Estimate</td>
									<td className='material'>Material</td>
									<td className='po'></td>
									<td className='location'></td>
									<td className='action'>Photos</td>
									<td className='action'></td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td className="checkboxes"><label><input type="checkbox" /></label></td>
									<td className="issue"><span className='issueNumber'>6</span></td>
									<td className='assignedTo'>Bob Smith</td>
									<td className='description'>Kitchen • Install backsplash doors, left and right of fridge, (need size, after counters are installed)</td>
									<td className='estimate'>1 hour</td>
									<td className='material' colSpan={3}>2-door panels, with backpainted glass (need size)</td>
									<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td className="checkboxes"><label><input type="checkbox" /></label></td>
									<td className="issue"><span className='issueNumber'>10</span></td>
									<td className='assignedTo'>Bob Smith</td>
									<td className='description'>Kitchen • Replace corner profile filler, came too short need 38 5/8 tall</td>
									<td className='estimate'>2 hours</td>
									<td className='material' colSpan={3}>Kitchen • Replace corner profile filler, came too short need 38 5/8 tall</td>
									<td className='action'><button className='icon iconOnly photos'><span>2</span></button></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>
		</div>
	</section>;
}

function CompletedSection() {
	return <section className='expander expanded'>
		<header><button tabIndex={ -1 }><span>Completed <span className='options'></span></span></button>
			<div className='icon iconExpander'><span></span><span></span></div>
			<div className='actions'><button className='icon iconOnly addItemWhite'><span></span></button></div>
		</header>
		<div className=''>

			{/* Visit */}
			<section className='expander expanded'>
				<header><button tabIndex={ -1 }><span>05/05/20 <span className='subtitle'></span></span></button>
					<div className='icon iconExpander'><span></span><span></span></div>
					<div className='actions'></div>
				</header>
				<div>
					<div className='inner clearfix'>
						<table className='sortable compact interactive' cellPadding='0' cellSpacing='0'>
							<thead>
								<tr>
									<td></td>
									<td className="checkboxes"></td>
									<td className='issue sorted'>No.</td>
									<td className='assignedTo'>Assigned to</td>
									<td className='description'>Description</td>
									<td className='estimate'></td>
									<td className='material'></td>
									<td className='po'></td>
									<td className='location'></td>
									<td className='action'>Photos</td>
									<td className='action'></td>
									<td></td>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td></td>
									<td className="checkboxes"></td>
									<td className="issue complete"><span className='issueNumber'>1</span></td>
									<td className='assignedTo'>Bob Smith</td>
									<td className='description' colSpan={5}>Install sink liner</td>
									<td className='action'><button className='icon iconOnly photos'><span>1</span></button></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td className="checkboxes"></td>
									<td className="issue complete"><span className='issueNumber'>2</span></td>
									<td className='assignedTo'>Bob Smith</td>
									<td className='description' colSpan={5}>Install icemaker panel</td>
									<td className='action'><button className='icon iconOnly photos disabled'><span>0</span></button></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
								<tr>
									<td></td>
									<td className="checkboxes"></td>
									<td className="issue complete"><span className='issueNumber'>3</span></td>
									<td className='assignedTo'>Bob Smith</td>
									<td className='description' colSpan={5}>Install roll out, will need to hang center partition, on right side of sink</td>
									<td className='action'><button className='icon iconOnly photos'><span>3</span></button></td>
									<td className='action'><button className='icon iconOnly contextMenu'><span></span></button></td>
									<td></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>
		</div>
	</section>;
}

export function JobEditService({ job, store }: Partial<IJobEditChildProps>) {
	const [saveRoot] = useSaveRoot<IOperationsModelFacade>({
		autoSave:  true,
		globalSave: true,
		warnOnLeave: true,
		stateId: `JobServiceEdit-${job?.key}`,
		modelFactory: operationsModelFacadeFactory,
		resolveMutableModel(current: IOperationsModelFacade | null) {
			const contracts = getCollection({ collection: ModelCollection.jobCosts }).filter(jc => jc.jobKey === job?.key && jc.isContract);
			const visits = getCollection({ collection: ModelCollection.siteVisits }).filter(sv => sv.jobKey === job?.key);
			let mutable = current;
			const rebase = mutable && mutable.needsRebase(job, contracts, visits);

			if(job && (!mutable || rebase)) {
				const mutableVisits = visits.toArray();

				if(rebase) {
					// be sure we don't lose any visits being added
					for(const v of mutable.visits) {
						if(!v.dateCreated && !mutableVisits.some(mv => mv.key === v.key)) {
							mutableVisits.push(v);
						}
					}
				}

				mutable = operationsModelFacadeFactory({ job, jobCosts: contracts.toArray(), visits: mutableVisits});
			}

			return [ mutable, rebase ]
		},
		save: async (doc: { job: IJob, jobCosts: IJobCost[], visits: ISiteVisit[] }, patch: IPatchOperation[]) => {
			// DR - saves need to be run serially to avoid api duplicate request pruning
			for(const p of patch) {

				if(p.path.indexOf('job/') === 0) {
					await jobActions.saveJob({ job: doc.job, patch: p.value });
				} else if(p.path.indexOf('jobCost/') === 0) {
					const jobCost = doc.jobCosts.find(jc => jc.key === p.path.replace('jobCost/', ''));

					await jobCostActions.saveJobCost({ jobCost, patch: p.value });
				} else if(p.path.indexOf('visit') === 0) {
					if(p.op === PatchOpType.add) {
						await siteVisitActions.saveSiteVisit({ siteVisit: p.value });
					}
					else if(p.op === PatchOpType.replace) {
						const visit = doc.visits.find(v => v.key === p.path.replace('visit/', ''));
	
						if(visit) {
							await siteVisitActions.saveSiteVisit({ siteVisit: visit, patch: p.value });
						}
					}
					else if(p.op === PatchOpType.remove) {
						await siteVisitActions.deleteSiteVisit({ siteVisit: { key: p.path.replace('visit/', '') } });
					}
				}
			}
		},
		processAlert(alert) {			
			return alert;
		},
		validate(model){
			const messages = [];
			for(const v of model.visits) {
				v.test(undefined, messages);
			}
			return messages;
		}
	});

	const files = getCollection({ collection: ModelCollection.files });
	const employees = getCollection({ collection: ModelCollection.employees });
	const vendors = getCollection({ collection: ModelCollection.vendors });
	const jobFiles = useMemo(() => {
		return files.filter(f => f.rootKey === job?.key ).toArray();
	}, [files, job]);

	const visits = useMemo(() => {
		return saveRoot.model?.visits || []; 
	}, [saveRoot.model]);
	const workAreas = useMemo(() => {
		return saveRoot.model?.jobCosts.flatMap(jc => jc.workAreas.toArray()); 
	}, [saveRoot.model]);
	const newIssues = useMemo(() => {
		return filter(saveRoot.model?.job.jobIssues?.toArray(), (i: IJobIssue) => i.currentStatus === JobIssueStatus.received); 
	}, [saveRoot.model]);
	const processingIssues = useMemo(() => {
		return filter(saveRoot.model?.job.jobIssues?.toArray(), (i: IJobIssue) => i.currentStatus === JobIssueStatus.processing); 
	}, [saveRoot.model]);

	// if(!saveRoot.model) {
	// 	return null;
	// }
    
	return <div>
		<NewIssuesSection employees={ employees } issues={ newIssues } visits={ visits } jobFiles={ jobFiles } workAreas={ workAreas } />
		<ProcessSection issues={ processingIssues } jobFiles={ jobFiles } vendors={ vendors } workAreas={ workAreas } />
		<ScheduledSection />
		<CompletedSection />
	</div>;
}